<template>
  <f-form
    store="@freebe/entrepreneurs"
    :id="id"
  >
    <template #default="{ item }">
      <div class="is-grid">
        <f-field 
          class="is-col-3 is-aligned"
          label="A la TVA ?"
          inline
        >
          <f-toggle 
            v-model="item.tva.is_subject"
            :readonly="!canEdit"
          ></f-toggle>
        </f-field>

        <div class="is-col-12"></div>

        <f-field 
          class="is-col-3"
          label="Date de début de TVA"
        >
          <f-datepicker 
            v-model="item.tva.since"
            :readonly="!canEdit"
            long
          ></f-datepicker>
        </f-field>

        <f-field 
          class="is-col-6"
          label="Numéro intra-communautaire"
        >
          <f-input 
            v-model="item.tva.numero"
            placeholder="Numéro de TVA"
            :readonly="!canEdit"
            long
          ></f-input>
        </f-field>
      </div>
    </template>
  </f-form>
</template>

<script>
  import useRoles from '@composables/use-roles'
  import { computed } from 'vue'

  export default {
    props: {
      id: {
        type: String,
        required: true,
      },
    },

    setup () {
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/entrepreneurs:patch')
      )

      return {
        canEdit,
      }
    }
  }
</script>